import React from 'react';
import { Grid, Box, Text, Button, Select } from '@mantine/core';
import { IconClearAll, IconSearch } from '@tabler/icons-react';
import type { IFiltroLogistica } from '../interfaces';
import type { LogisticaCatalogos } from './constantesTablaLogistica';

/** Valor del filtro de máquina para las filas sin máquina (aplican a cualquier máquina). */
export const FILTRO_SIN_MAQUINA = 0;

interface FiltroLogisticaVistaProps {
  filtro: IFiltroLogistica;
  catalogos: LogisticaCatalogos;
  alCambiarFiltro: (campo: keyof IFiltroLogistica, valor: number | undefined) => void;
  alConsultar: () => void;
  alLimpiar: () => void;
}

/** Filtros de la matriz de Logística (mismo estilo que los filtros de tabla de Equipos, Clientes, etc.). */
export const FiltroLogisticaVista: React.FC<FiltroLogisticaVistaProps> = ({ filtro, catalogos, alCambiarFiltro, alConsultar, alLimpiar }) => (
  <Box pl="md" pr="md" pb="sm" pt="sm">
    <Grid gutter="sm">
      <Grid.Col span={{ base: 12, md: 4 }}>
        <Select
          placeholder="Producto"
          clearable
          searchable
          size="xs"
          comboboxProps={{ zIndex: 5000 }}
          data={catalogos.productos}
          value={filtro.ProductoId?.toString() ?? null}
          onChange={(valor) => alCambiarFiltro('ProductoId', valor ? Number(valor) : undefined)}
        />
      </Grid.Col>

      <Grid.Col span={{ base: 12, md: 4 }}>
        <Select
          placeholder="Máquina"
          clearable
          searchable
          size="xs"
          comboboxProps={{ zIndex: 5000 }}
          data={[{ value: String(FILTRO_SIN_MAQUINA), label: 'Sin máquina' }, ...catalogos.maquinas]}
          value={filtro.MaquinaId?.toString() ?? null}
          onChange={(valor) => alCambiarFiltro('MaquinaId', valor !== null ? Number(valor) : undefined)}
        />
      </Grid.Col>

      <Grid.Col
        span={{ base: 12, md: 4 }}
        style={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'flex-end', gap: '0.5rem' }}
      >
        <Button
          onClick={alLimpiar}
          color="primary"
          variant="light"
          size="compact-sm"
          radius="lg"
          rightSection={<IconClearAll opacity={1} size={12} />}
        >
          <Text fw={500} fz={11}>Limpiar</Text>
        </Button>

        <Button
          onClick={alConsultar}
          color="primary"
          variant="filled"
          size="compact-sm"
          radius="lg"
          rightSection={<IconSearch opacity={1} size={12} />}
        >
          <Text fw={500} fz={11}>Consultar</Text>
        </Button>
      </Grid.Col>
    </Grid>
  </Box>
);
